import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button } from '@mui/material';
import api from '../../api';

const LeaveNHAdd = ({ empId, showMsg, setActiveTab }) => {
  const [nhForm, setNhForm] = useState({ name: '', date: '' });

  const handleNhSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/settings/national-holidays', nhForm);
      showMsg("National Holiday Added!");
      setNhForm({ name: '', date: '' });
      setActiveTab('nh_manage');
    } catch (err) { 
      showMsg(err.response?.data?.detail || "Failed", "error"); 
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 4, borderRadius: 2, maxWidth: 500 }}>
      <Typography variant="h6" color="primary" gutterBottom sx={{ fontWeight: 'bold' }}>Add National Holiday</Typography>
      <Box component="form" onSubmit={handleNhSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <TextField size="small" type="date" label="Holiday Date" required InputLabelProps={{ shrink: true }} value={nhForm.date} onChange={e => setNhForm({...nhForm, date: e.target.value})} />
        <TextField size="small" label="Holiday Name" required value={nhForm.name} onChange={e => setNhForm({...nhForm, name: e.target.value})} />
        <Button type="submit" variant="contained">Save Holiday</Button>
      </Box>
    </Paper>
  );
};

export default LeaveNHAdd;